<div class="custom-select-wrapper" [attr.dir]="dir">
  <label *ngIf="label" [for]="inputId" [class]="labelClass">
    {{ label }}
  </label>
  <div class="custom-select" [class.open]="isOpen" #selectContainer>
    <!-- Selected value display -->
    <div [class]="triggerClass" (click)="toggleDropdown()"
         [class.has-value]="multiple ? selectedValues.length > 0 : hasValue"
         [class.is-disabled]="disabled"
         [class.is-invalid]="showError">
      <!-- Multi-select: show tags -->
      <ng-container *ngIf="multiple; else singleSelect">
        <div class="selected-tags" *ngIf="selectedValues.length > 0; else placeholder">
          <span class="selected-tag" *ngFor="let opt of getSelectedOptions()">
            {{ opt.title }}
            <i class="remove-tag" (click)="removeSelection(opt.id, $event)">&times;</i>
          </span>
        </div>
      </ng-container>
      <!-- Single select: show value -->
      <ng-template #singleSelect>
        <span *ngIf="hasValue; else placeholder">
          {{ getSelectedLabel() }}
        </span>
      </ng-template>
      <ng-template #placeholder>
        <span class="placeholder-text">{{ placeholderText }}</span>
      </ng-template>
      <i class="arrow-icon" [class.rotate]="isOpen">▼</i>
    </div>
    <!-- Dropdown menu -->
    <div class="select-dropdown" *ngIf="isOpen">
      <!-- Search input — masqué sur les listes courtes (voir searchThreshold) -->
      <div class="search-box p-2" *ngIf="showSearch">
        <input type="text" class="form-control bg-input" [(ngModel)]="searchTerm" (input)="onSearch()"
          [placeholder]="'FORMS.SEARCH' | translate" #searchInput [disabled]="isAddingOption" />
      </div>
      <!-- Options list -->
      <div class="options-list">
        <div *ngFor="let option of filteredOptions" class="option-item p-3"
          [class.selected]="isSelected(option.id)" (click)="selectOption(option)">
          <span class="option-checkbox" *ngIf="multiple">
            <i *ngIf="isSelected(option.id)" class="fa-solid fa-square-check"></i>
            <i *ngIf="!isSelected(option.id)" class="fa-regular fa-square"></i>
          </span>
          {{ option.title }}
        </div>
        <!-- No results found -->
        <div *ngIf="filteredOptions.length === 0 && searchTerm && !isAddingOption" class="no-results p-3">
          <span>{{ 'FORMS.NO_RESULTS' | translate }}</span>
        </div>
        <!-- Add new option -->
        <div *ngIf="allowAdd && searchTerm && !exactMatchExists()" class="add-new-option p-3" (click)="addNewOption()"
          [class.loading]="isAddingOption">
          <i class="plus-icon" *ngIf="!isAddingOption">+</i>
          <span *ngIf="isAddingOption">{{ 'FORMS.ADDING' | translate }}...</span>
          <span *ngIf="!isAddingOption">{{ 'FORMS.ADD_NEW' | translate }}: "{{ searchTerm }}"</span>
        </div>
      </div>
    </div>
  </div>
  <!-- Validation error -->
  <div *ngIf="showError" class="invalid-feedback d-block">
    {{ errorMessage }}
  </div>
</div>